import { AppState } from '../container/App/interface';
import { initialState } from '../container/App/reducer';
import { getCMSConfig } from './cms';
import { ProviderType } from '../container/App/enum';

const isUMProduct = (id: string): boolean => id.includes('um');

/**
 * Modify and return the draftState based on window.additionalPageOptions.
 * @param {AppState} draftState draftState
 * @returns {AppState} draftState
 */
const getStateFromCmsConfig = (draftState: AppState): AppState => {
    const { selectedId, routerIds } = getCMSConfig();

    draftState.selectedId = selectedId;
    draftState.providerType = isUMProduct(selectedId) ? ProviderType.UM : ProviderType.VKD;
    draftState.availableRouterIds = Object.values(routerIds);

    return draftState;
};

/**
 * Load state from additionalPageOptions.
 * @returns {Partial<AppState>} Object containing partial information for initialization.
 */
export const loadInitialAppState = (): Partial<AppState> => {
    // Note: Deep copy of state
    let draftState: AppState = JSON.parse(JSON.stringify(initialState));

    draftState = getStateFromCmsConfig(draftState);

    return draftState;
};
